import ProxyBase from '../../../../core/proxies/ProxyBase'

class Proxy extends ProxyBase {
  getDetailData({ path, params }) {
    return this.post(path, params)
  }

  getSummaryHighlight(params) {
    return this.post('PortfolioInsights/Score/Highlight', params)
  }

  getMaxDate(params) {
    return this.post('PortfolioInsights/MaxDate', params)
  }
}

export default new Proxy()
